import { render, staticRenderFns } from "./UsersAndPermissibles.vue?vue&type=template&id=5892fec5&scoped=true&"
import script from "./UsersAndPermissibles.vue?vue&type=script&async=true&lang=js&"
export * from "./UsersAndPermissibles.vue?vue&type=script&async=true&lang=js&"
import style0 from "./UsersAndPermissibles.vue?vue&type=style&index=0&id=5892fec5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5892fec5",
  null
  
)

export default component.exports